// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-7ba6bc9e]{border-radius:8px;padding:4px 12px}.wrapper[data-v-7ba6bc9e],span[data-v-7ba6bc9e]{cursor:pointer}.text-span-wrapper[data-v-7ba6bc9e]{word-break:break-word;display:inline-block}.wrapper[data-v-7ba6bc9e]:hover{background-color:#f3f3f3;border-radius:8px;transition:background-color .3s}.font-icon[data-v-7ba6bc9e]{color:#adb7be;font-size:14px}.placeholder[data-v-7ba6bc9e]{color:#aaa}", ""]);
// Exports
module.exports = exports;
